import React from 'react'
import { news, } from "../translate";
import { useEffect, useState } from 'react';
import Api from '../Api';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

// Register only what you use
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
export default function NewsGraffic({ setSide, newsData }) {
    const [data, setData] = useState({
        labels: [],
        datasets: [],
    });

    const [members,setMembers] = useState([])
    useEffect(() => {
        (async () => {
            const { data } = await Api.getStatistic()
            setMembers(data.row)
            const labels = data.rows.map(news => news.title_hy);
            const views = data.rows.map(news => news.views);
            setData({
                labels,
                datasets: [
                    {
                        label: "Դիտումների քանակ",
                        data: views,
                        backgroundColor: '#007bff',
                        borderRadius: 5,
                        barThickness: 30,
                    },
                ],
            });
        })()
    }, [])
    return (
        <div>
            <div style={{ cursor: "pointer", padding: 16, height: 63 }} className="d-flex align-items-center">
                <span onClick={() => setSide("news")}>{news.news[+localStorage.getItem('atsLang') || 1]}</span>
                <div className="header_border" style={{ height: 30, backgroundPosition: 'center' }} />
                <span onClick={() => setSide("graff")}>Գրաֆիկ</span>
            </div>
            <div style={{ padding: 30, }}>
                <Bar
                    data={data}
                    options={{
                        responsive: true,
                        plugins: {
                            legend: { position: 'top' },
                            title: { display: true, text: 'News Article Views' },
                        },
                        scales: {
                            x: {
                                ticks: {
                                    maxRotation: 45,
                                    minRotation: 30,
                                    autoSkip: false,
                                },
                            },
                            y: {
                                beginAtZero: true,
                            },
                        },
                    }}
                />
            </div>
            <div style={{ maxWidth: 700, margin: '20px auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }} border="1" cellPadding="8">
                    <thead>
                        <tr>
                            <th style={{padding:10}}>User</th>
                            <th style={{padding:10}}>Total Views</th>
                        </tr>
                    </thead>
                    <tbody>
                        {members.map(({ member_id, member_fio, total_views }) => (
                            <tr key={member_id}>
                                <td style={{padding:10}}>{member_fio}</td>
                                <td style={{padding:10}}>{total_views}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}
